
/**
 * ! 点击导航栏定位到目标位置（注：不能再初始时刻获取，因为部分元素懒加载可能导致初始暂存的高度有误，导致跳转不准确）
 * @param {HTMLElement} target 所点击的定位元素
 */

function jumpToTarget(target, offset = 0) {
  const countrySelectContainer = document.querySelector('#countrySelectContainer') // 多家选择
  const stickyNav = document.querySelector('.xmmune') // 快速导航栏
  const breadnavSticky = document.querySelector('.section-breadnav-sticky__inner') // 新面包屑导航栏
  const countryContainerH = countrySelectContainer?.getBoundingClientRect()?.height || 0
  const stickyNavH = stickyNav?.getBoundingClientRect()?.height || 0
  const breadnavStickyH = breadnavSticky?.getBoundingClientRect()?.height || 0
  const H = 65 + stickyNavH + countryContainerH + breadnavStickyH // 国家选择栏高度可能出现可能不出现
  const _target = document.querySelector(typeof target === 'string' ? target : target.dataset.pointId)
  console.log(`%c>> $target, _target, countryContainerH, stickyNavH, H`, 'color:yellow', target, _target, countryContainerH, stickyNavH, breadnavStickyH, H)
  const targetPosition = _target.getBoundingClientRect().top + window.scrollY - H - offset
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth' // 平滑滚动
  })
}

/**
 * 获取url参数
 * @param {String} name url参数字段
 */
function getParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return !!name ? urlParams.get(name) : urlParams;
}

/**
 * 添加/修改 URL 参数（不刷新页面）
 * @param {string} key - 参数名
 * @param {string} value - 参数值
 * @param {boolean} [replace=false] - 是否替换历史记录（使用 replaceState）
 */
function updateUrlParam(key, value, replace = false) {
  // 创建当前 URL 的副本
  const url = new URL(window.location.href);
  
  // 添加/修改参数
  url.searchParams.set(key, value);
  
  // 使用 History API 更新 URL
  if (replace) {
    window.history.replaceState({}, '', url);
  } else {
    window.history.pushState({}, '', url);
  }
}
